'use strict';

/**
 *
 * @name: compile
 *
 */

import {passPropToAddonYouTube, passPropToAddonSlideshow, passPropToAddonVimeo} from './compile-helpers'

function CompileDirective($compile, $rootScope) {

  'ngInject';

  return {
    restrict: 'A',
    replace: true,
    link: function(scope, element, attr) {
      const {
        preventChange,
      } = attr

      function passPropToAddons (originalHtml) {
        const prop = 'post'
        return passPropToAddonVimeo(
          passPropToAddonYouTube(
            passPropToAddonSlideshow(originalHtml, prop),
            prop
          ),
          prop
        )
      }

      if(!preventChange){
        if (scope.post.translations && scope.post.translations[$rootScope.lang]) {
          const originalHtml = scope.post.translations[$rootScope.lang].content
          const newHtml = passPropToAddons(originalHtml)
          element.html(newHtml);
        }
      } else {
        const originalHtml = scope.item.seasons[0].translations[$rootScope.lang].description
        const newHtml = passPropToAddons(originalHtml)
        element.html(newHtml);
      }

      const contents = element.contents()
      $compile(contents)(scope);
    }
  };
}

export default CompileDirective;



// WEBPACK FOOTER //
// ./app/components/nn-add-ons/nn-compile.directive.js